export default {
    default_image: require('@assets/img/bg/default-image.jpg'),
    master_card_logo: require('@assets/img/logo/master_card_logo.png'),
    atm_card_logo: require('@assets/img/logo/atm_card_logo.png'),
    jcb_card_logo: require('@assets/img/logo/jcb_card_logo.png'),
    visa_card_logo: require('@assets/img/logo/visa_card_logo.png'),
}